<!-- eslint-disable no-empty -->
<template>
  <div class="page page-add">
    <div class="page-container">
      <div class="page-title">创建表单</div>
      <div class="w1200">
        <div class="panel">
          <a-form-model ref="form" :model="form" :rules="rules" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }" class="form-class">
            <h3 class="text-center v-mb-md">基本信息</h3>
            <div class="panel-body">
              <a-row :gutter="0">
                <a-col span="12">
                  <a-form-model-item label="表单名称" :colon="false" prop="activityName">
                    <a-input placeholder="表单名称" allowClear v-model="form.activityName" ref="activityName" />
                  </a-form-model-item>
                </a-col>
                <a-col span="12">
                  <a-form-model-item label="表单编号" :colon="false">
                    <a-input :value="'hd_' + $moment().year() + ('000' + (activityMaxId + 1)).slice(-3)" :disabled="true"></a-input>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row :gutter="0">
                <a-col span="12">
                  <a-form-model-item label="表单申请时间" :colon="false" prop="applyDate">
                    <a-range-picker :placeholder="['开始时间', '结束时间']" style="width: 377px" v-model="form.applyDate" ref="applyDate" />
                  </a-form-model-item>
                </a-col>
                <a-col span="12">
                  <a-form-model-item label="表单类型" :colon="false" prop="activityTypeId">
                    <a-row>
                      <a-col span="16">
                        <a-select placeholder="选择表单类型" v-model="form.activityTypeId" style="width: 100%" allowClear ref="activityTypeId" :options="activityTypes" show-search :filter-option="filterOption" />
                      </a-col>
                      <a-col span="1"></a-col>
                      <a-col span="7">
                        <a-button type="primary" style="width: 100%" @click="openTypeManage">表单分类管理</a-button>
                      </a-col>
                    </a-row>
                  </a-form-model-item>
                </a-col>
              </a-row>

              <a-row>
                <a-col>
                  <a-form-model-item :colon="false" prop="activity_remark" label="对应项目" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
                    <a-select show-search placeholder="输入关键字筛选项目" style="width: 100%" v-model="form.projectId" option-filter-prop="children" :filter-option="filterOption">
                      <a-select-option v-for="project in allProjects" :key="project.id" :value="project.id">
                        {{ project.name }}
                      </a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
                <a-col>
                  <a-form-model-item :colon="false" prop="activity_remark" label="表单说明" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
                    <Toolbar style="border-bottom: 1px solid #ccc" :editor="editor" :defaultConfig="toolbarConfig" :mode="mode" />
                    <Editor style="height: 500px; overflow-y: hidden" v-model="form.description" :defaultConfig="editorConfig" :mode="mode" @onCreated="onEditorCreated" />
                  </a-form-model-item>
                </a-col>
                <a-col>
                  <a-form-item :colon="false" prop="activity_resource" label="表单材料" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
                    <a-upload-dragger
                      :multiple="true"
                      :show-upload-list="{
                        showDownloadIcon: true,
                      }"
                      :action="`${baseURL}/activity/file/upload`"
                      :data="{ params: JSON.stringify({ fileSign: 'activity', fileType: 1 }) }"
                      @download="file => downloadFile(file.response.result)"
                      @change="handleUploadChange"
                    >
                      <div class="v-pa-xs">
                        <a-icon type="file-add" style="margin-bottom: 10px" />
                        <p class="font-xs">点击选择文件或拖拽文件至此区域</p>
                      </div>
                    </a-upload-dragger>
                  </a-form-item>
                </a-col>
                <a-col>
                  <a-form-model-item :colon="false" prop="activity_remark" label="提交完成后" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
                    <a-radio-group default-value="0" v-model="form.afterOperate" button-style="solid">
                      <a-radio-button value="0">无操作</a-radio-button>
                      <a-radio-button value="1">显示文本</a-radio-button>
                      <a-radio-button value="2">跳转到指定页面</a-radio-button>
                    </a-radio-group>
                    <transition name="after-text">
                      <div v-if="form.afterOperate == 1">
                        <Toolbar style="border-bottom: 1px solid #ccc" :editor="editor2" :defaultConfig="toolbar2Config" :mode="mode" />
                        <Editor style="height: 300px; overflow-y: hidden" v-model="form.afterText" :defaultConfig="editor2Config" :mode="mode" @onCreated="onEditor2Created" />
                      </div>
                    </transition>
                    <div v-if="form.afterOperate == 2">
                      <a-input placeholder="请输入页面地址" v-model="form.afterUrl" />
                    </div>
                  </a-form-model-item>
                </a-col>
              </a-row>

              <a-row :gutter="0">
                <a-col span="12">
                  <a-form-model-item label="表单申请表" :colon="false">
                    <a-switch v-model="form.hasInstance" />
                  </a-form-model-item>
                </a-col>
              </a-row>
            </div>
          </a-form-model>

          <div class="panel" v-if="form.hasInstance">
            <a-form-model class="form-class" ref="fields_form" :model="fieldsForm" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
              <h3 class="text-center v-mb-md">配置申请表字段</h3>
              <a-row :gutter="0" class="v-px-md">
                <a-col span="12">
                  <a-form-model-item label="申请表最大填报人数" :colon="false" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
                    <a-input-number placeholder="最大填报人数" allowClear v-model="form.instanceLimit" ref="instanceLimit" style="width: 230px" />
                    <div class="ant-form-explain">最大填报人数，-1表示不限制</div>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <table class="table table-plain" style="margin-top: 10px">
                <tr>
                  <th width="5%" style="text-align: center; border-bottom: 0px">序号</th>
                  <th width="18%" style="text-align: left; border-bottom: 0px">字段名称</th>
                  <th width="25%" style="text-align: left; border-bottom: 0px">字段说明</th>
                  <th width="27%" style="text-align: left; border-bottom: 0px">字段类型</th>
                  <th width="10%" style="text-align: center; border-bottom: 0px">必填</th>
                  <th width="10%" style="text-align: center; border-bottom: 0px">操作</th>
                </tr>
                <tr style="border: 0px">
                  <td colspan="6" name="fieldTable" style="padding: 0px !important; border: 0px !important">
                    <table style="width: 100%" v-for="(item, index) in fieldList" :key="index" :data-id="index">
                      <tr style="background-color: #fff; height: 60px">
                        <td width="5%" style="text-align: center">{{ index + 1 }}</td>
                        <td width="18%">
                          <a-input placeholder="字段名称" allowClear v-model="item.fieldName" type="textarea" :auto-size="{ minRows: 4, maxRows: 20 }" />
                        </td>
                        <td width="25%"><a-input placeholder="字段说明" allowClear v-model="item.fieldDesc" type="textarea" :auto-size="{ minRows: 4, maxRows: 20 }" /></td>
                        <td width="27%" style="vertical-align: top">
                          <a-select placeholder="字段类型" v-model="item.fieldType" style="width: 100%" allowClear ref="subject">
                            <a-select-option :value="1">
                              <span slot="label">
                                <a-icon type="edit" />
                                单行文本
                              </span>
                            </a-select-option>
                            <a-select-option :value="4">
                              <span slot="label">
                                <a-icon type="form" />
                                多行文本
                              </span>
                            </a-select-option>
                            <a-select-option :value="7">
                              <span slot="label">
                                <a-icon type="number" />
                                数字
                              </span>
                            </a-select-option>
                            <a-select-option :value="2">
                              <span slot="label">
                                <a-icon type="check-circle" />
                                单选项
                              </span>
                            </a-select-option>
                            <a-select-option :value="5">
                              <span slot="label">
                                <a-icon type="check-square" />
                                多选项
                              </span>
                            </a-select-option>
                            <a-select-option :value="3">
                              <span slot="label">
                                <a-icon type="file-add" />
                                附件
                              </span>
                            </a-select-option>
                            <a-select-option :value="6">
                              <span slot="label">
                                <a-icon type="calendar" />
                                日期
                              </span>
                            </a-select-option>
                            <a-select-option :value="8">
                              <span slot="label">
                                <a-icon type="bars" />
                                小标题
                              </span>
                            </a-select-option>
                            <a-select-option :value="9">
                              <span slot="label">
                                <a-icon type="home" />
                                地区
                              </span>
                            </a-select-option>
                          </a-select>
                          <div v-if="item.fieldType == 2 || item.fieldType == 5">
                            <a-input placeholder="多个选择项内容以#号分隔" allowClear v-model="item.selectVals" style="margin-top: 10px" type="textarea" />
                            <a-checkbox v-if="item.fieldType == 2" v-model="item.withOther">其他</a-checkbox>
                          </div>
                          <div v-if="item.fieldType == 3" style="margin-top: 5px">
                            <div>
                              <span>最小上传文件数：</span>
                              <a-input-number v-model="item.min" :min="1" size="small" style="width: 80px" />
                            </div>
                            <div style="margin-top: 5px">
                              <span>最大上传文件数：</span>
                              <a-input-number v-model="item.max" :min="1" size="small" style="width: 80px" />
                            </div>
                          </div>
                          <!-- <div v-else class="shadow-block"></div> -->
                        </td>
                        <td width="10%" style="text-align: center">
                          <a-switch v-if="item.fieldType != 8" v-model="item.required" checked-children="是" un-checked-children="否" />
                        </td>
                        <td width="10%" style="text-align: center">
                          <!-- <span class="item">排序</span> -->
                          <a-button type="link" icon="drag" class="drag" title="拖动排序"></a-button>
                          <a-button type="link" @click="onRemoveActivity(index)" icon="close" title="删除"></a-button>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
              <div style="margin-top: 20px; margin-right: 8px; text-align: right">
                <a-button size="small" type="primary" icon="plus" @click="onAddActivity">增加表单字段</a-button>
              </div>
            </a-form-model>
            <TypeManage ref="TypeManage" />
          </div>
        </div>

        <a-affix :offset-bottom="10" :target="() => this.$refs.container">
          <div class="text-center v-mt-sm">
            <a-space>
              <a-button icon="save" @click="onSave(0)" :loading="saving">保存初稿</a-button>
              <a-button icon="publish" type="primary" @click="onSave(1)" :loading="saving">保存，发布表单</a-button>
              <a-button icon="rollback" type="danger" @click="$router.go(-1)">返回</a-button>
            </a-space>
          </div>
        </a-affix>
      </div>
    </div>
  </div>
</template>

<script>
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import { addActivity, removeFile, allProjects, activityTypeList, activityMaxId } from '@/api/activity'
import Sortable from 'sortablejs'
import TypeManage from './type-manage'
import { baseURL } from '@/utils/const'

const form = {
  applyDate: undefined,
  instanceLimit: -1,
  hasInstance: true,
}

export default {
  components: { Editor, Toolbar, TypeManage },
  data() {
    return {
      form: { ...form },
      fieldList: [],
      sortedFieldListIndex: [],
      rules: {
        activityName: [{ required: true, message: '请输入表单名称', trigger: 'blur' }],
        activityType: [{ required: true, message: '请选择表单类型', trigger: 'blur' }],
        applyDate: [{ required: true, message: '请选择表单申请时间', trigger: 'change' }],
      },
      fileMark: this.$utils.uuid(),
      fileList: [],

      fieldsForm: {},
      allProjects: [],

      editor: null,
      html: '',
      toolbarConfig: {
        excludeKeys: ['fullScreen', 'group-video'],
        modalAppendToBody: true,
      },
      editorConfig: {
        placeholder: '',
        MENU_CONF: {
          customUpload: file => {
            console.log('customUpload---------t', file)
          },
          uploadImage: {
            server: baseURL + '/file/editor/upload',
            maxFileSize: 10 * 1024 * 1024,
            fieldName: 'editorFile',
            allowedFileTypes: ['image/*'],
            // onSuccess(file, res) {
            //   console.log(`${file.name} 上传成功`, res)
            // },
            // onBeforeUpload(file) {
            //   console.log('onBeforeUpload', file)
            //   return file
            // },
            // onFailed(file, res) {
            //   console.log(`${file.name} 上传失败`, res)
            // },
            onError: this.onImageUploadError,
            customInsert(res, insertFn) {
              let url = res.data.url
              url = baseURL + url
              insertFn(url)
            },
          },
        },
      },

      editor2: null,
      html2: '',
      toolbar2Config: {
        excludeKeys: ['fullScreen', 'group-video'],
        modalAppendToBody: true,
      },
      editor2Config: {
        placeholder: '',
        MENU_CONF: {
          customUpload: file => {
            console.log('customUpload---------t', file)
          },
          uploadImage: {
            server: baseURL + '/file/editor/upload',
            maxFileSize: 10 * 1024 * 1024,
            fieldName: 'editorFile',
            allowedFileTypes: ['image/*'],
            onError: this.onImageUploadError,
            customInsert(res, insertFn) {
              let url = res.data.url
              url = baseURL + url
              insertFn(url)
            },
          },
        },
      },

      mode: 'default',
      activityTypes: [],
      activityMaxId: null,
      saving: false,
    }
  },
  computed: {},
  methods: {
    onImageUploadError(file) {
      if (file.size > 10 * 1024 * 1024) {
        this.$message.warn('图片大小不能超过10M')
      }
    },
    openTypeManage() {
      this.$refs.TypeManage.open()
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    loadAllProjects() {
      allProjects().then(({ data }) => {
        this.allProjects = data.result
      })
    },
    onSave(status) {
      this.$message.destroy()
      this.$refs.form.validate(valid => {
        if (valid) {
          let params = this.form
          // if (!this.fieldList || this.fieldList.length == 0) {
          //   this.$message.warning('配置申请表字段不能为空')
          //   return
          // }
          for (let i = 0; i < this.fieldList.length; i++) {
            let field = this.fieldList[i]
            if (!field.fieldName || field.fieldName === '') {
              this.$message.warning('配置申请表字段【序号' + (i + 1) + '】:字段名称不能空')
              return
            }
            if (!field.fieldType) {
              this.$message.warning('配置申请表字段【序号' + (i + 1) + '】:字段类型不能空')
              return
            } else {
              if (field.fieldType == 2 && (!field.selectVals || field.selectVals === '')) {
                this.$message.warning('配置申请表字段【序号' + (i + 1) + '】:选择项属性不能空')
                return
              }
            }
            if (field.fieldType == 3 && field.min && field.max && field.min > field.max) {
              this.$message.warning('配置申请表字段【序号' + (i + 1) + '】:最小上传文件数不能大于最大上传文件数')
              return
            }
          }
          if (params.afterOperate == 0) {
            params.afterText = null
            params.afterUrl = null
          } else if (params.afterOperate == 1) {
            if (!params.afterText || params.afterText == '<p><br></p>') {
              this.$message.warning('请编写添加完成后显示文本内容')
              return
            }
            params.afterUrl = null
          } else if (params.afterOperate == 2) {
            if (!params.afterUrl) {
              this.$message.warning('请输入添加完成后跳转页面地址')
              return
            }
            params.afterText = null
          }
          params.applyStartdate = this.$moment(this.form.applyDate[0]).locale('zh-cn').format('YYYY-MM-DD')
          params.applyEnddate = this.$moment(this.form.applyDate[1]).locale('zh-cn').format('YYYY-MM-DD')
          for (let field of this.fieldList) {
            if (field.selectVals) {
              field.selectVals = field.selectVals.split('#')
            }
          }
          let fieldListResult = null
          if (this.sortedFieldListIndex.length > 0) {
            let newFieldList = []
            for (let index of this.sortedFieldListIndex) {
              newFieldList.push({ ...this.fieldList[index] })
            }
            fieldListResult = newFieldList
          } else {
            fieldListResult = this.fieldList
          }
          params.fieldsConfigStr = JSON.stringify(fieldListResult)
          params.activityStatus = status
          params.fileIds = this.fileList.map(file => file.response.result.fileId)
          params.instanceExist = params.hasInstance ? 1 : 0
          this.saving = true
          addActivity(params)
            .then(({ data }) => {
              if (data.success) {
                this.$message.success('保存表单成功')
                this.id = data.result
                this.$router.go(-1)
              } else {
                this.$message.error('保存表单失败')
              }
              this.saving = false
            })
            .catch(() => {
              this.$message.error('保存表单失败')
            })
        }
      })
    },
    handleUploadChange({ file, fileList }) {
      if (file.status === 'done') {
        this.fileList = [...fileList]
      } else if (file.status === 'removed') {
        this.fileList = [...fileList]
        let fileId = file.response.result.fileId
        removeFile({ fileId })
      }
    },
    onAddActivity() {
      this.fieldList.push({ key: this.$utils.randomStr(9) })
    },
    onRemoveActivity(index) {
      this.fieldList.splice(index, 1)
    },
    onEditorCreated(ed) {
      let editor = Object.seal(ed)
      // 可监听 `modalOrPanelShow` 和 `modalOrPanelHide` 自定义事件来设置样式、蒙层
      editor.on('modalOrPanelShow', modalOrPanel => {
        if (modalOrPanel.type !== 'modal') return
        const { $elem } = modalOrPanel // modal element
        const width = $elem.width()
        const height = $elem.height()
        // set modal position z-index
        $elem.css({
          left: '50%',
          top: '50%',
          marginLeft: `-${width / 2}px`,
          marginTop: `-${height / 2}px`,
          zIndex: 1000,
        })
        // show mask div
        document.getElementById('mask').style.display = 'block'
      })
      editor.on('modalOrPanelHide', () => {
        // hide mask div
        document.getElementById('mask').style.display = 'none'
      })
      editor.on('modalOrPanelHide', () => {
        // 隐藏蒙层
      })
      this.editor = editor
    },
    onEditor2Created(ed) {
      let editor = Object.seal(ed)
      // 可监听 `modalOrPanelShow` 和 `modalOrPanelHide` 自定义事件来设置样式、蒙层
      editor.on('modalOrPanelShow', modalOrPanel => {
        if (modalOrPanel.type !== 'modal') return
        const { $elem } = modalOrPanel // modal element
        const width = $elem.width()
        const height = $elem.height()
        // set modal position z-index
        $elem.css({
          left: '50%',
          top: '50%',
          marginLeft: `-${width / 2}px`,
          marginTop: `-${height / 2}px`,
          zIndex: 1000,
        })
        // show mask div
        document.getElementById('mask').style.display = 'block'
      })
      editor.on('modalOrPanelHide', () => {
        // hide mask div
        document.getElementById('mask').style.display = 'none'
      })
      editor.on('modalOrPanelHide', () => {
        // 隐藏蒙层
      })
      this.editor2 = editor
    },
    loadActivityTypes() {
      activityTypeList().then(res => {
        let activityTypes = []
        for (let at of res.data.result) {
          activityTypes.push({ label: at.name, value: at.id })
        }
        this.activityTypes = activityTypes
      })
    },
    loadMaxId() {
      activityMaxId().then(res => {
        this.activityMaxId = res.data.result
      })
    },
    initFieldTableDraggable() {
      let that = this
      var el = document.getElementsByName('fieldTable')[0]
      var ops = {
        animation: 500,
        handle: '.drag',
        onEnd: function () {
          //获取拖动后的排序
          that.sortedFieldListIndex = sortable.toArray()
        },
      }
      const sortable = Sortable.create(el, ops)
    },
  },
  mounted() {
    this.loadAllProjects()
    // this.onAddActivity()
    this.loadActivityTypes()
    this.loadMaxId()
    this.initFieldTableDraggable()
  },
}
</script>

<style lang="stylus">
.form-class{
    background-color: #f4f4fa;
    padding: 20px;
    border-radius: 3px;
    margin-bottom: 20px;
}
.shadow-block{
  background-color: #FAFAFA;
  height: 55px;
  width: 100%;
  margin-top: 6px;
  border-radius: 3px;
}
.after-text-enter-active,
.after-text-leave-active {
  transition: max-height 0.5s ease-out;
}
.after-text-enter,
.after-text-leave-to {
  max-height: 0;
  overflow: hidden;
}
</style>
